import React, { useContext } from "react";
import { surveyService } from "../../services/survey.service"
import { Skeleton,Table } from "antd";

const UserActivityTransactionInformation = (props) => {
  const [dataSource, setDataSource] = React.useState([])
  
  const getData = async () =>{
    let userActivityTransactionInformation= await surveyService.getUserActivity()
    let dataSource=userActivityTransactionInformation.map(item=>
      ({
        id:item.id,
        typeOfSurvey:item.survey_type==1&&'Anketa JLS'||item.survey_type==2&&'Ponuda građani'||item.survey_type==3&&'Ponuda JLS'||item.survey_type==4&&'Potražnja građani'||item.survey_type==5&&'Ponuda gospodarski subjekti'||item.survey_type==6&&'Anketa građani',
        jlsName:item.name=='Grad Zagreb'&&item.name||item.type_of_settlement==1&&`Općina ${item.name}`||item.type_of_settlement==2&&`Grad ${item.name}`,
        verificationStatus:item.verification_status==0&&'Čeka potvrdu'||item.verification_status==1&&'Prihvaćena'||item.verification_status==2&&'Odbijena'||item.verification_status==3&&'U statusu verifikacije'||item.verification_status==4&&'Postavljena kao sporedna',
        loginTime:(item.created.split('T')[1].split(':')[0]==0&&'23'||item.created.split('T')[1].split(':')[0]-1)+":"+item.created.split('T')[1].split(':')[1]+":"+item.created.split('T')[1].split(':')[2].split('.')[0],
        loginDate:item.created.split('T')[0].split('-')[2]+'.'+item.created.split('T')[0].split('-')[1]+'.'+item.created.split('T')[0].split('-')[0]+'.'
      })    
      
      )
      setDataSource(dataSource)
}

const columns = [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
    sorter: (a, b) => a.id-b.id
  },

  {
    title: 'Vrsta Ankete',
    dataIndex: 'typeOfSurvey',
    key: 'typeOfSurvey',
    sorter: (a, b) => a.typeOfSurvey?.localeCompare(b.typeOfSurvey),
    filters:[
      {
        text: 'Anketa JLS',
        value: 'Anketa JLS',
      },
      {
        text: 'Ponuda građani',
        value: 'Ponuda građani',
      },
      {
        text: 'Ponuda JLS',
        value: 'Ponuda JLS',
      },
      {
        text: 'Potražnja građani',
        value: 'Potražnja građani',
      },
      {
        text: 'Ponuda gospodarski subjekti',
        value: 'Ponuda gospodarski subjekti',
      },
      {
        text: 'Anketa građani',
        value: 'Anketa građani',
      },
    ],
    onFilter: (value, record) => record.typeOfSurvey?.indexOf(value) === 0,
  },
  {
    title: 'Lokacija prijave',
    dataIndex: 'jlsName',
    key: 'jlsName',
  },
  {
   
  },
  {
    title: 'Status verifikacije',
    dataIndex: 'verificationStatus',
    key: 'verificationStatus',
    sorter: (a, b) => a.verificationStatus?.localeCompare(b.verificationStatus),
    filters:[
      {
        text: 'Čeka potvrdu',
        value: 'Čeka potvrdu',
      },
      {
        text: 'Prihvaćena',
        value: 'Prihvaćena',
      },
      {
        text: 'Odbijena',
        value: 'Odbijena',
      },
      {
        text: 'U statusu verifikacije',
        value: 'U statusu verifikacije',
      },
      {
        text: 'Postavljena kao sporedna',
        value: 'Postavljena kao sporedna',
      },
    ],
    onFilter: (value, record) => record.verificationStatus?.indexOf(value) === 0,
  },  
  {
    title: 'Vrijeme prijave',
    dataIndex: 'loginTime',
    key: 'loginTime',
  },
  {
    title: 'Datum prijave',
    dataIndex: 'loginDate',
    key: 'loginDate',
  },
];
React.useEffect(() => {
  const fetchData = async () => {
     await Promise.all([getData()]);
  }  
  fetchData();
},[])


    return (
    <>      
    {dataSource&&<Table dataSource={dataSource} columns={columns} />}
</>

    )
}

export default UserActivityTransactionInformation;